<template>
    <div class="account">
        <el-form :inline="true" :model="formInline" :class="{marginLeft:active }"
                 style="padding-top: 10px;margin-left: 18px;width: 98%">

            <router-link to="/home/pharmacy/newinto">
                <el-button type="primary">+新增入库</el-button>
            </router-link>

            <div style="float: right; display: inline-block">
                <el-date-picker v-model="chartTimeValue"
                                :clearable="false"
                                type="daterange" align="center" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions2">
                </el-date-picker>
                <el-form-item label=" 入库单号:">
                    <el-input style="width: 150px" placeholder="入库单号" v-model="inStoreId" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-icon-search" @click="onSubmit()"></el-button>
                </el-form-item>
            </div>
        </el-form>

        <el-table border :data="tableData" style="width: 100%!important;margin-left: 18px" :header-cell-style="tableHeaderColor">
            <el-table-column prop="id" label="入库单号" width="auto"></el-table-column>
            <el-table-column prop="date" label="入库日期" width="auto"></el-table-column>
            <el-table-column prop="supplier" label="供应商"></el-table-column>
            <el-table-column prop="supplierPhone" label="供应商联系方式"></el-table-column>
            <el-table-column prop="username" label="制单人"></el-table-column>
            <el-table-column prop="remarks" label="备注"></el-table-column>
            <el-table-column prop="status" label="状态" width="auto"
                             :filters="[{ text: '待审核', value: '待审核' },
                             { text: '已审核', value: '已审核' },{ text: '已退药', value: '已退药' }]"
                             :filter-method="filterTag" filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status==='待审核' ? 'danger' : (scope.row.status==='已审核' ? 'success' : 'info')">
                        {{scope.row.status}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template scope="scope">
                    <div v-if="scope.row.status=='待审核'">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
                        <el-button type="text" size="small" @click="audit(scope.row)">审核</el-button>
                        <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
                            删除
                        </el-button>
                    </div>
                    <div v-else-if="scope.row.status=='已审核'">
                        <el-button type="text" size="small" @click="checkClick(scope.row)">查看详情</el-button>
                    </div>

                </template>

            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync=Current
                    :page-size=this.Size
                    layout="total,prev, pager, next, jumper"
                    :total=this.total>
            </el-pagination>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .account {
        width: 99%;
        padding-bottom: 50px;
        background-color: white;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .el-table .warning-row {
        background: #ffaaa3;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    el-input {
        width: 100px;
    }

    .stylecolor {
        /*background-color: red;*/
        color: red;
    }

    .marginLeft {
        margin-left: 20px;
    }

</style>

<script>
    import {formatDate} from "../../common/date";

    export default {

        username: 'account',
        data() { 
            return {
                options: [],
                tableData: [],
                dataList: {},
                total: 0,
                Current: 1,
                Size: 10,
                currentPage: 0,  //当前页数
                value1: '全部',
                inStoreId: '',
                chartTimeValue: [Date.now() - 8.64e7 * 6, Date.now()],
                active: true,
                formInline: {
                    user: '',
                    region: '',
                    account: '',
                },
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },

            }
        },
        //实例化就获取数据
        mounted: function () {
            this.dataList = {
                startDate: formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
                endDate: formatDate(this.chartTimeValue[1], 'yyyy-MM-dd'),
                inStoreId: ''
            };
            this.getinfo();
        },

        methods: {
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                  return "background-color:#f2f2f2;color: #a4a7af;";                }
            },
            getinfo: function () {
                this.$axios({
                    url: '/api/medicine/instore/pageNumber/' + this.Current + '/size/' + this.Size,
                    method: 'POST',
                    data: this.dataList
                }).then(res => {
                    this.tableData = res.data.data.content;
                    this.total = res.data.data.totalElements;
                }).catch(err => {
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.Size = val;
            },
            handleCurrentChange(val) {
                this.Current = val;
                this.getinfo();
            },
            //删除
            deleteRow(index, rows) {
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var delId = this.tableData[index].id;
                    this.$axios({
                        url: '/api/medicine/instore/' + delId,
                        method: 'DELETE'
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.getinfo();
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            filterTag(value, row) {
                return row.status === value;
            },
            //修改
            handleClick: function (row) {
                this.$router.push({path: "./newinto", query: {id: row.id}});
            },
            //查看详情
            checkClick: function (row) {
                this.$router.push({path: "./check", query: {id: row.id}})
            },
            //审核
            audit: function (row) {
                this.$router.push({path: "./audit", query: {id: row.id}})
            },
            onSubmit: function () {
                let n = /^[0-9]*$/;
                if (n.test(this.inStoreId)) {
                } else {
                    this.$message({
                        type: "danger",
                        message: '入库单号格式不正确'
                    })
                    return
                }
                this.Current=1;
                this.dataList.inStoreId = this.inStoreId;
                this.dataList.startDate = formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
                    this.dataList.endDate = formatDate(this.chartTimeValue[1], 'yyyy-MM-dd');
                this.getinfo();
            }


        }

    }

</script>




// WEBPACK FOOTER //
// intoHouse.vue?be620d78